import { render } from "./Monev.vue?vue&type=template&id=36bdbae5"
import script from "./Monev.vue?vue&type=script&lang=js"
export * from "./Monev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__